// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { connect } from "react-redux";
import React, { useEffect, useCallback } from "react";
import * as R from "ramda";

import { Filter as StyledFilter, ListItem, SubHeading } from "./styles";
import { setForm } from "src/actions/forms";
import { getWorkflowInstanceFilter } from "src/reducers";
import BlanksNonBlanks from "src/components/Manage/Workflow/Instances/Table/Filter/BlanksNonBlanks";
import { Separator } from "src/components/Manage/Workflow/Instances/Table/Filter/styles";

import type { AppState, WorkflowInstanceFilter } from "src/types";

type Props = {
  parentRef: any,
  column: string,
  filter: WorkflowInstanceFilter,
  _setForm: Function,
  handleClose: Function,
  withoutBox?: boolean,
  filterShown?: boolean
};

const Sort = ({
  parentRef,
  column,
  filter,
  _setForm,
  handleClose,
  withoutBox,
  filterShown
}: Props) => {
  const closeModal =
    ((event: any) => {
      if (event.keyCode === 13) {
        handleClose();
      }
    },
    [handleClose]);

  const clickOutside = useCallback(
    (event: any) => {
      if (parentRef && parentRef.current) {
        if (!parentRef.current.contains(event.target)) {
          handleClose();
        }
      }
    },
    [parentRef, handleClose]
  );

  useEffect(() => {
    // $FlowFixMe
    document.addEventListener("keydown", closeModal, false);
    document.addEventListener("click", clickOutside, false);
    return () => {
      // $FlowFixMe
      document.removeEventListener("keydown", closeModal, false);
      document.removeEventListener("click", clickOutside, false);
    };
  }, []);

  const handleSort = useCallback(
    (ascending: boolean) => {
      if (ascending) {
        const newColumn = R.uniq([
          `${column}:asc`,
          ...R.reject(R.equals(`${column}:desc`), filter.sort || [])
        ]);

        _setForm({
          query: {
            ...filter,
            sort: newColumn,
            page: 1
          }
        });
      } else {
        const newColumn = R.uniq([
          `${column}:desc`,
          ...R.reject(R.equals(`${column}:asc`), filter.sort || [])
        ]);

        _setForm({
          query: {
            ...filter,
            sort: newColumn,
            page: 1
          }
        });
      }
    },
    [filter, _setForm]
  );

  const handleSelect = useCallback(
    (event: any, item: string | number) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (R.includes(item, filter[column] || [])) {
        _setForm({
          query: {
            ...filter,
            [column]: R.reject(R.equals(item), filter[column]),
            page: 1
          }
        });
      } else {
        _setForm({
          query: {
            ...filter,
            [column]: [...(filter[column] || []), item],
            page: 1
          }
        });
      }
    },
    [column, filter, _setForm]
  );

  if (withoutBox) {
    return (
      <>
        <SubHeading>{i18n.t(k.SORT_BY2)}</SubHeading>
        <ul>
          <ListItem tabIndex="0" role="button" onClick={() => handleSort(true)}>
            {i18n.t(k.ASCENDING)}
          </ListItem>
          <ListItem
            tabIndex="0"
            role="button"
            onClick={() => handleSort(false)}
          >
            {i18n.t(k.DESCENDING)}
          </ListItem>
        </ul>
        {filterShown && (
          <>
            <Separator />
            <SubHeading>{i18n.t(k.FILTER)}</SubHeading>
            <BlanksNonBlanks
              handleSelect={handleSelect}
              filter={filter[column]}
            />
          </>
        )}
      </>
    );
  }

  return (
    <StyledFilter>
      <SubHeading>{i18n.t(k.SORT_BY2)}</SubHeading>
      <ul>
        <ListItem tabIndex="0" role="button" onClick={() => handleSort(true)}>
          {i18n.t(k.ASCENDING)}
        </ListItem>
        <ListItem tabIndex="0" role="button" onClick={() => handleSort(false)}>
          {i18n.t(k.DESCENDING)}
        </ListItem>
      </ul>
      {filterShown && (
        <>
          <Separator />
          <SubHeading>{i18n.t(k.FILTER)}</SubHeading>
          <BlanksNonBlanks
            handleSelect={handleSelect}
            filter={filter[column]}
          />
        </>
      )}
    </StyledFilter>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  filter: getWorkflowInstanceFilter(app)
});

export default connect(mapStateToProps, {
  _setForm: setForm
})(Sort);
